import React from "react";
import { BarChart, XAxis, YAxis, Bar, Tooltip } from "recharts";
import styled from "styled-components";
import { getBarRadius } from "./util";

const CircleDot = styled.span`
  height: 8px;
  width: 8px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
`;

type GenderBarProps = {
  data: any,
  totalCount: number,
  hideLabels?: boolean,
  width?: number,
  height?: number
}

const GenderBar = (props: GenderBarProps) => {
  const { data, totalCount, hideLabels, width, height } = props;
  let barData: any = [{
    name: 'Gender',
    "women": data['cmetrics-female'],
    "men": data['cmetrics-male']
  }]
  const hasUnknown = totalCount - data["cmetrics-female"] - data["cmetrics-male"];
  if (!hideLabels) {
    barData[0]["unknown"] = hasUnknown;
  }
  const hasMen = data['cmetrics-male'] > 0;
  const hasUnknownLabel = !hideLabels && hasUnknown > 0;
  const hasWomen = data['cmetrics-female'] > 0;
  
  const womenRadius = getBarRadius({ hasLeft: false, hasRight: hasMen || hasUnknownLabel });
  const menRadius = getBarRadius({ hasLeft: hasWomen, hasRight: hasUnknownLabel });
  const unknownRadius = getBarRadius({ hasLeft: hasWomen || hasMen, hasRight: false });
  
  return (<>
    <BarChart layout="vertical" width={width || 600} height={ height || 20} data={barData}>
      <XAxis hide type="number" domain={[0, totalCount]} />
      <YAxis hide dataKey="name" type="category" />
      {!hideLabels && (<Tooltip wrapperStyle={{ zIndex: 1000 }} />)}
      <Bar dataKey="women" isAnimationActive={false} stackId="a" fill="rgba(48, 141, 248, 1)" radius={womenRadius} />
      <Bar dataKey="men" isAnimationActive={false} stackId="a" fill="rgba(48, 141, 248, 0.8)" radius={menRadius}/>
      <Bar dataKey="unknown" isAnimationActive={false} stackId="a" fill="rgba(48, 141, 248, 0.4)" radius={unknownRadius} />
    </BarChart>
    {!hideLabels && (<div>
      <span style={{ padding: '0 10px' }}><CircleDot style={{ backgroundColor: 'rgba(48, 141, 248, 1)' }} />Women ({Math.floor(((data['cmetrics-female'] || 0)*100)/totalCount)}%)</span>
      <span style={{ padding: '0 10px' }}><CircleDot style={{ backgroundColor: 'rgba(48, 141, 248, 0.8)' }} /> Men ({Math.floor(((data['cmetrics-male'] || 0)*100)/totalCount)}%)</span>
      <span style={{ padding: '0 10px' }}><CircleDot style={{ backgroundColor: 'rgba(48, 141, 248, 0.4)' }} /> Unknown ({Math.floor(((totalCount - ((data['cmetrics-female'] || 0) + (data['cmetrics-male'] || 0)))*100)/totalCount)}%)</span>
    </div>)}
  </>);
}

export default GenderBar;
